import { useCallback } from 'react';

import Tooltip from '@mui/material/Tooltip';
import DownloadIcon from '@mui/icons-material/Download';
import { GridActionsCellItem } from '@mui/x-data-grid';

import { downloadFile } from './utils/download-file.util';
import type { FileItem } from './types/file-item.type';

interface DownloadActionProps {
  readonly file: FileItem;
}

export const DownloadAction = ({ file }: Readonly<DownloadActionProps>) => {
  const handleClick = useCallback(() => {
    downloadFile(file.uri);
  }, [file.uri]);

  const actionLabel = 'Télécharger';

  return (
    <GridActionsCellItem
      icon={
        <Tooltip title={actionLabel}>
          <DownloadIcon fontSize="inherit" />
        </Tooltip>
      }
      label={actionLabel}
      onClick={handleClick}
    />
  );
};
